/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:5c708119-7f75-40ee-b333-360d557211d3",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_FWV3rtxPM",
    "aws_user_pools_web_client_id": "4it9dffmcdnmi158u4q6m1oa4o",
    "oauth": {},
    "aws_content_delivery_bucket": "vueserverlessproject-20190201030125-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "http://vueserverlessproject-20190201030125-hostingbucket-prod.s3-website.us-east-2.amazonaws.com",
    "aws_appsync_graphqlEndpoint": "https://r7a4ulry5vfwlimxbdcvj5baua.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "notifyReviewers",
            "endpoint": "https://0dpftnqq9f.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        }
    ],
    "aws_user_files_s3_bucket": "auditimages9384873192-prod",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
